import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Inject,
  Page,
  Sort,
  PagerComponent,
  DetailRow,
} from "@syncfusion/ej2-react-grids";
import { L10n } from "@syncfusion/ej2-base";
import "./DataTable.css";

L10n.load({
  "en-US": {
    pager: {
      itemsPerPage: "",
      currentPageInfo: "",
      totalItemsInfo: "Showing {1} to {2} of {0}",
    },
  },
});

const DataTable = ({
  data,
  columns,
  height = 510,
  grid,
  handlePageChange,
  currentPage,
  defaultPaging = true,
  isDetailTemplate = false,
  allowSorting = false,
  handleSorting = () => {},
  rowSelected = () => {},
}) => {
  const handlePageClick = (args) => {
    handlePageChange(args.currentPage);
  };

  const tableColumns =
    columns && columns.length > 0
      ? columns.map((column) => (
          <ColumnDirective
            key={column.key}
            field={column.field}
            headerText={column.headerText}
            width={column.width}
            textAlign={column.alignment}
            template={column.template}
            allowSorting={column?.allowSorting}
            headerTemplate={column?.headerTemplate}
          />
        ))
      : null;

  const detailTemplate = (rowData) => {
    return (
      <div
        className="text-center py-3 m-0"
        style={{ backgroundColor: "#f7f6f0" }}
      >
        <strong>Incident:</strong> {rowData?.incident?.details}
      </div>
    );
  };

  return (
    <>
      <GridComponent
        ref={grid}
        dataSource={data}
        allowPaging={defaultPaging}
        detailTemplate={isDetailTemplate ? detailTemplate : undefined}
        allowSorting={allowSorting}
        allowTextWrap={true}
        allowscrolling="true"
        enableAdaptiveUI={true}
        height={height}
        locale="en-US"
        key={data.length}
        rowSelected={rowSelected}
        actionBegin={handleSorting}
      >
        <ColumnsDirective>{tableColumns}</ColumnsDirective>
        <Inject services={[Sort, Page, DetailRow]} />
      </GridComponent>
      {!defaultPaging && (
        <PagerComponent
          // pageCount={data[0]?.pageSettings?.pageCount}
          pageSize={data[0]?.pageSettings?.pageSize}
          currentPage={currentPage}
          totalRecordsCount={data[0]?.pageSettings?.totalRecordsCount}
          click={handlePageClick}
        />
      )}
    </>
  );
};
export default DataTable;
